import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import '../configs/swagger.css';
import {useAppContext} from "../../../../contexts/AppContext";
import {useParams} from "react-router-dom";

export function DocumentationViewer() {
    const { token } = useAppContext();
    const apiUrl = process.env.REACT_APP_API;
    const { docName } = useParams();

    return (
        <SwaggerUI
            url={`${apiUrl}dev-docs/${docName}?t=${Date.now()}`}
            requestInterceptor={(req) => {
                req.headers['Authorization'] = `Bearer ${token}`;
                req.headers['Content-Type'] = 'application/json';
                return req;
            }}
        />
    );
}